import { useEffect, useState, memo } from 'react'
import { LegendButtonType } from '../../interfaces'

const LegendButton = memo(
  ({ checked, text, handleChange }: LegendButtonType) => {
    const [cls, setCls] = useState('wc-rainfall__checkbox')
    useEffect(() => {
      checked
        ? setCls('wc-rainfall__checkbox wc-rainfall__checkbox--checked')
        : setCls('wc-rainfall__checkbox')
    }, [checked])

    return (
      <label
        className={`wc-rainfall__button${
          checked ? ' wc-rainfall__button--checked' : ''
        }`}
      >
        <span
          onClick={handleChange}
          onKeyUp={(e) => {
            if (e.keyCode === 13) {
              handleChange()
            }
          }}
          role="checkbox"
          aria-checked={checked}
          tabIndex={0}
        >
          <span className={cls}>
            <input type="checkbox" checked={checked} onChange={() => {}} />
          </span>

          <h4>{text}</h4>
        </span>
      </label>
    )
  }
)

export default LegendButton
